import { useEffect } from 'react';
import { Route, Routes, Navigate, useLocation } from 'react-router-dom';
import { Box } from '@mui/material';

import { AdminPage } from './pages/AdminPage';
import { LoginPage } from './pages/LoginPage';
import { ProfessionalCreationPage } from './pages/ProfessionalCreationPage';
import { RegisterPage } from './pages/RegisterPage';
import { EmailConfirmationPage } from './pages/EmailConfirmationPage';
import { SharedLayout } from './pages/SharedLayout';
import { UserProfilePage } from './pages/UserProfilePage';

// import {  BusinessSetupPage, 
//           BusinessNamePage, 
//           BusinessServicesPage, 
//           BusinessTeamSizePage, 
//           BusinessLocationPage, 
//           BusinessCurrentSoftwarePage, 
//           BusinessReferralPage,
//           BusinessCreationSuccessPage } from './pages/BusinessCreation';
import { BusinessCreationProvider } from "./context/BusinessCreationContext";


import './App.css';
import Home from './pages/Home';
import CompaniesDirectory from './pages/Companies/CompaniesDirectory.jsx';
import ObjectivesPage from './pages/Objectives/ObjectivesPage.jsx';
import AboutProgram from './pages/AboutProgram/AboutProgram.jsx';
import ManufacturersPage from './pages/Manufacturers/ManufacturersPage.jsx';
import ProductsPage from './pages/Products/ProductsPage.jsx';
import BenefitsPage from './pages/Benefits/BenefitsPage.jsx';
import LabelPage from './pages/Label/LabelPage.jsx';
import PartnersPage from './pages/Partners/PartnersPage.jsx';
import NewsPage from './pages/News/NewsPage.jsx';
import ContactPage from './pages/Contact/ContactPage.jsx';
import FAQsPage from './pages/FAQs/FAQsPage.jsx';
import EligibilityPage from './pages/Eligibility/EligibilityPage.jsx';
import HowToApplyPage from './pages/HowToApply/HowToApplyPage.jsx';
import ProgramEventsPage from './pages/ProgramEvents/ProgramEventsPage.jsx';
import KnowledgeHubPage from './pages/KnowledgeHub/KnowledgeHubPage.jsx';
import MembersDirectoryPage from './pages/MembersDirectory/MembersDirectoryPage.jsx';
import "@fontsource/architects-daughter";
import { useDispatch, useSelector } from "react-redux";
import { checkToken } from './app/services/user.slice';
import Theme from "./helpers/theme";
import { authenticationService } from './app/services/authentication.service';
import { setProfile } from './app/services/user.slice';


const App = () => {
  const user = useSelector(state => state.user);
  const dispatch = useDispatch();
  const location = useLocation();

useEffect(() => {
  dispatch(checkToken());

  if (localStorage.getItem("token")) {
    authenticationService.getUserByToken().then((profile) => {
      dispatch(setProfile(profile));
    });
  }
}, [dispatch]);

  useEffect(() => {
    if (user.token && !user.authenticated) {
      // 
      dispatch(checkToken());
      return;
    }
  }, [user, dispatch]);


  return (
    
   <BusinessCreationProvider>
    <Theme>
      <Box style={{ height: '100hv' }} >
        <Routes>
          <Route exact path="/" element={<SharedLayout />} >
            <Route path="/confirm-email/:userId/:token" element={(<EmailConfirmationPage />)} />
            <Route path="login" state={{ from: location }} element={!user.authenticated ? (<LoginPage />) : (<Navigate to="/companies" replace />)} />
            <Route path="register" element={!user.authenticated ? (<RegisterPage />) : (<Navigate to="/companies" replace />)} />

              {/* <Route path="/businesssetup" element={<BusinessSetupPage />} />
              <Route path="/businessname" element={<BusinessNamePage />} />
              <Route path="/businessservices" element={<BusinessServicesPage />} />
              <Route path="/businessteamsize" element={<BusinessTeamSizePage />} />
              <Route path="/businesslocation" element={<BusinessLocationPage />} /> */}
              {/* <Route path="/businesscurrentsoftware" element={<BusinessCurrentSoftwarePage />} />
              <Route path="/businessreferral" element={<BusinessReferralPage />} /> */}
              {/* <Route path="/businesscreationsuccess" element={<BusinessCreationSuccessPage />} /> */}

            <Route path="professionalcreation" element={<ProfessionalCreationPage />} />
            <Route index element={<Home />} />
            <Route path="companies" element={<CompaniesDirectory />} />

            <Route path="about" element={<AboutProgram />} />
            <Route path="objectives" element={<ObjectivesPage />} />
            <Route path="manufacturers" element={<ManufacturersPage />} />
            <Route path="products" element={<ProductsPage />} />
            <Route path="benefits" element={<BenefitsPage />} />
            <Route path="label" element={<LabelPage />} />
            <Route path="partners" element={<PartnersPage />} />
            <Route path="news" element={<NewsPage />} />
            <Route path="contact" element={<ContactPage />} />
            <Route path="faqs" element={<FAQsPage />} />
            <Route path="eligibility" element={<EligibilityPage />} />
            <Route path="how-to-apply" element={<HowToApplyPage />} />
            <Route path="program-events" element={<ProgramEventsPage />} />
            <Route path="knowledge-hub" element={<KnowledgeHubPage />} />
            <Route path="members-directory" element={<MembersDirectoryPage />} />

            {/* <Route path="/availability/:params" element={<ProfessionalAvailability />} /> */}
            {/* <Route path="schedule" element={user.authenticated ? (<Schedule />) : (<Navigate to="/login" replace state={{ from: location }} />)} /> */}
            <Route path="admin" element={user.authenticated ? (<AdminPage />) : (<Navigate to="/login" replace state={{ from: location }} />)} />
            <Route path="Profile" element={user.authenticated ? (<UserProfilePage />) : (<Navigate to="/login" replace state={{ from: location }} />)} />
          </Route>
        </Routes>
      </Box>
    </Theme>
    </BusinessCreationProvider>
  );
}

export default App;


